<template>
    <div class="lo wrapper">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">

    .lo.wrapper {
        display: flex;
        position: relative;
        flex-direction: column;
        transition: $transition;
        min-height: 100vh;

        &::before {
            @extend %mask;
            content: none;
            z-index: 7;
        }
    }
</style>
